import { render, staticRenderFns } from "./PriorityMark.vue?vue&type=template&id=6f99c1a2&scoped=true&"
import script from "./PriorityMark.vue?vue&type=script&lang=js&"
export * from "./PriorityMark.vue?vue&type=script&lang=js&"
import style0 from "./PriorityMark.vue?vue&type=style&index=0&id=6f99c1a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99c1a2",
  null
  
)

export default component.exports